import { render, staticRenderFns } from "./AssetComponentPopup.vue?vue&type=template&id=031d4869&"
import script from "./AssetComponentPopup.vue?vue&type=script&lang=js&"
export * from "./AssetComponentPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports